import { useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingShell from "./_Shell";
import { BUSINESS_TYPES } from "../../lib/businessDefaults";
import { getOrCreateOnboarding, saveOnboarding } from "../../lib/onboarding";

export default function OnboardingStep1() {
  const navigate = useNavigate();
  const ob = getOrCreateOnboarding();

  const [selectedType, setSelectedType] = useState<string>(
    (ob as Record<string, unknown>).businessType as string ?? ""
  );

  function handleContinue() {
    saveOnboarding({ ...ob, businessType: selectedType } as Parameters<typeof saveOnboarding>[0]);
    navigate("/onboarding/2");
  }

  return (
    <OnboardingShell
      step={1}
      title="What type of business are you?"
      subtitle="We'll set up your AI with smart defaults for your industry."
    >
      <div
        className="grid gap-3 mb-6"
        style={{
          gridTemplateColumns: "repeat(2, 1fr)",
        }}
      >
        {BUSINESS_TYPES.map((biz) => {
          const isSelected = selectedType === biz.id;

          return (
            <button
              key={biz.id}
              type="button"
              onClick={() => setSelectedType(biz.id)}
              className="rounded-xl p-4 text-left transition-all cursor-pointer"
              style={{
                background: isSelected
                  ? "rgba(138, 43, 226, 0.15)"
                  : "rgba(255, 255, 255, 0.04)",
                border: isSelected
                  ? "2px solid transparent"
                  : "2px solid rgba(255, 255, 255, 0.08)",
                backgroundClip: isSelected ? undefined : undefined,
                outline: "none",
                boxShadow: isSelected
                  ? "0 0 0 2px #8a2be2, 0 0 0 3px #ff6a00"
                  : "none",
              }}
            >
              <i
                className={`${biz.icon} text-2xl block mb-2`}
                style={{
                  color: isSelected ? "#c084fc" : "rgba(255,255,255,0.5)",
                }}
              />
              <span
                className="text-sm font-semibold leading-snug"
                style={{
                  color: isSelected ? "#ffffff" : "rgba(255,255,255,0.7)",
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
              >
                {biz.label}
              </span>
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={handleContinue}
        disabled={!selectedType}
        className="w-full rounded-xl px-4 py-3 text-sm font-semibold text-white transition-opacity disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
        style={{
          background: "linear-gradient(90deg, #8a2be2, #ff6a00)",
          fontFamily: "'Space Grotesk', sans-serif",
        }}
      >
        Continue →
      </button>
    </OnboardingShell>
  );
}
